import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import {formatPhoneNumeric, toDateString} from '../../../providers/app-date-adapter';
import { Order } from '../../../dto/order';

import { OrderStatus } from '../../../dto/order-status';
import { OrderCancellationModel } from '../../../models/order-cancellation-model';
import { OrderCancelDialogComponent } from '../../../shared/order-cancel-dialog/order-cancel-dialog.component';
import { RoleService } from '../../../services/role.service';
import { CardsService } from '../../services/cards.service';
import { PrevNextModel } from '../../../models/prev-next-model';
import { getTableFilters } from '../../../helpers/storage-helper';
import {TotalCardOrder} from '../../../dto/total-card-order';
import {TotalCardOrdersService} from '../../services/total-card-orders.service';
import {FileHelper} from '../../../helpers/file-helper';
import {ObjectComment} from '../../../dto/object-comment';
import {ObjectCommentsService} from '../../services/object-comment.service';
import {TotalStatsCard, TotalStatsProduct, TotalStatsTransaction} from '../../../dto/total-stats-transaction';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-total-card-order-view',
  templateUrl: './total-card-order-view.component.html',
  styleUrls: ['./total-card-order-view.component.css']
})
export class TotalCardOrderViewComponent implements OnInit {

  totalCardOrder: TotalCardOrder;

  comments: ObjectComment[];
  commentsTarget = 4;


  prevNext: PrevNextModel;
  loadingOrder: boolean;
  loadCardData: boolean;
  totalCardOrderId: number;

  selectedTotalCard: TotalStatsCard = null;
  totalStatCardProducts: TotalStatsProduct[] = [];

  fields = [
    // { header: "ExternalRef", cell: (row: Order) => `${row.externalRef}` },
    // { header: "Card name", cell: (row: Order) => `${row.cardName}` },
    // { header: "Invoice number", link: (row: Order) => (row ? `/invoices/by-number/${row.invoiceNumber}` : null), cell: (row: Order) => `${row.invoiceNumber || "Voucher"}` },
    // { header: "Sex", cell: (row: Order) => `${row.sex}` },

    { header: 'Order Ref.', cell: (row: TotalCardOrder) => `${row.orderRef}` },
    { header: 'Company', cell: (row: TotalCardOrder) => `${row.companyName}` },
    { columnDef: 'corporateForm', header: 'Corporate Form', cell: (row: TotalCardOrder) => `${row.corporateForm != null ? row.corporateForm.name : '' }` },
    { header: 'Address', cell: (row: TotalCardOrder) => `${row.address}` },
    { header: 'ZIP', cell: (row: TotalCardOrder) => `${row.zipCode}` },
    { header: 'City', cell: (row: TotalCardOrder) => `${row.city}` },
    { header: 'Country', cell: (row: TotalCardOrder) => `${row.country ? row.country.name : '-'}` },
    { header: 'Landline', cell: (row: TotalCardOrder) => `${row.landline}` },

    { header: 'Contact Person', cell: (row: TotalCardOrder) => `${row.firstName} ${row.lastName}` },
    { header: 'Date of birth', cell: (row: TotalCardOrder) => `${toDateString(row.dob) || ''}` },
    { header: 'Email', cell: (row: TotalCardOrder) => `${row.email}` },
    { header: 'Mobile', cell: (row: TotalCardOrder) => `${formatPhoneNumeric(row.phone)}` },
    // { header: "Phone", cell: (row: TotalCardOrder) => `${formatPhoneNumeric(row.phone)}` },
    // { header: "Nationality", cell: (row: Order) => `${row.nationality}` },
    { header: 'Order language', cell: (row: TotalCardOrder) => {
        if ( row.orderLanguage == 0 ) {
          return 'german';
        } else {
          return 'english';
        }
      } },
    { header: 'Ip Address', cell: (row: TotalCardOrder) => `${row.ipAddress}` },
    { header: 'Order date', cell: (row: TotalCardOrder) => `${toDateString(row.orderDate) || ''}` },
    { header: 'Status', cell: (row: TotalCardOrder) => `${row.statusName}` },


  ];

  cancellationFields = [
    { header: 'Cancellation reason', cell: (row: Order) => `${row.cancellationReasonName}` },
    { header: 'Cancellation comment', cell: (row: Order) => `${row.cancellationComment}` },
  ];
  loadingHistory: boolean;
  totalStatCards: TotalStatsCard[];
  selectedTotalProduct: TotalStatsProduct = null;
  totalStatTransactions: TotalStatsTransaction[];
  totalTotalProductAmountNet: number;
  totalTotalProductQuantity: number;

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private totalCardOrdersService: TotalCardOrdersService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public roleService: RoleService,
    public cardService: CardsService,
    private objectCommentsService: ObjectCommentsService,
  ) { }



  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      const idParam = params['id'];
      this.clearData();
      this.initComponent(idParam);
      this.totalCardOrderId = idParam;

      this.objectCommentsService.getForObject( idParam, this.commentsTarget ).subscribe( data => {
        this.comments = data;
      });



    });

  }

  initComponent(orderId: number) {
    this.getOrderById(orderId);
    this.getPrevNext(orderId);
  }
  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }

  updateOrder() {
    this.totalCardOrdersService.get(this.totalCardOrderId).subscribe(result => {
      this.totalCardOrder = result;
    });
  }

  returnBack() {
    this.location.back();
  }

  cancelOrderDisabled() {
    return this.totalCardOrder && (this.totalCardOrder.status == OrderStatus.Activated || this.totalCardOrder.status == OrderStatus.Cancelled);
  }

  cancelOrder() {
    this.dialog.open(OrderCancelDialogComponent, { data: { orderId: this.totalCardOrder.id } }).afterClosed()
      .subscribe(dlgResult => {
        if (dlgResult instanceof OrderCancellationModel) {
          this.totalCardOrdersService.cancelOrder(dlgResult).subscribe(result => {
            this.updateOrder();
            this.snackBar.open('Total Card Order has been cancelled', null, {
              duration: 5000,
              panelClass: ['app-mat-snack-bar']
            });
          });
        }
      });
  }

  allowEditOrder() {
    // return this.totalCardOrder && this.totalCardOrder.status < OrderStatus.Shipped;
    return false;
  }

  getOrdersTableFilters() {
    return getTableFilters('ordersTable');
  }

  getPrevNext(id: number) {
    const filters = this.getOrdersTableFilters();
    this.totalCardOrdersService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });
  }

  gotoPrevOrder() {
    const filters = this.getOrdersTableFilters();
    this.totalCardOrdersService.getPrev(filters, this.totalCardOrderId).subscribe(result => {
      this.router.navigate(['..', result], { relativeTo: this.route });
    });
  }

  gotoNextOrder() {
    const filters = this.getOrdersTableFilters();
    this.totalCardOrdersService.getNext(filters, this.totalCardOrderId).subscribe(result => {
      this.router.navigate(['..', result], { relativeTo: this.route });
    });
  }

  getOrderById(orderId: number) {
    this.loadingOrder = true;
    this.totalCardOrdersService.get(orderId)
      .subscribe(order => {
          this.totalCardOrder = order;
          this.loadingOrder = false;
          this.loadingHistory = true;

          this.totalCardOrdersService.getCustomerTotalCards(this.totalCardOrder.id).subscribe(totalStatCards => {
            this.totalStatCards = totalStatCards;
            if ( this.totalStatCards.length === 1) {
              this.selectedTotalCard = this.totalStatCards[0];
              this.changeTotalStatCard();
            }
            this.loadingHistory = false;
          });


        },
        err => {
 this.loadingOrder = false;
});
  }

  clearData() {
    this.prevNext = null;
  }

  downloadAttachment() {
    this.totalCardOrdersService.getPdfFormAttachment(parseInt(this.route.snapshot.paramMap.get('id'))).subscribe(
      result => {


        FileHelper.saveFile(result);
      },
      err =>
        this.snackBar.open(err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: ['app-mat-snack-bar']
        })
    );
  }



  confirmOrder() {
    alert('Error');
  }

  changeTotalStatCard() {

    this.selectedTotalProduct = null;
    this.totalStatTransactions = [];
    this.totalStatCardProducts = [];
    this.totalTotalProductAmountNet = 0;
    this.totalTotalProductQuantity = 0;
    this.loadingHistory = true;

    this.totalCardOrdersService.getProductsForTotalCard(this.selectedTotalCard.id).subscribe(totalStatProducts => {
      this.totalStatCardProducts = totalStatProducts;
      if ( this.totalStatCardProducts.length === 1) {
        this.selectedTotalProduct = this.totalStatCardProducts[0];
        this.changeTotalStatProduct();
      }
      this.loadingHistory = false;
    });

  }

  changeTotalStatProduct() {
    // alert(this.selectedTotalProduct.productCode);
    this.totalCardOrdersService.getTransactionsForTotalCard(this.selectedTotalCard.id, this.selectedTotalProduct.id, 5).subscribe(totalStatTransactions => {
      this.totalStatTransactions = totalStatTransactions;
      this.totalCardOrdersService.getTransactionsForTotalCardTotalAmountNet(this.selectedTotalCard.id, this.selectedTotalProduct.id).subscribe(totalAmount => {
        this.totalTotalProductAmountNet = totalAmount;
      });
      this.totalCardOrdersService.getTransactionsForTotalCardTotalQuantity(this.selectedTotalCard.id, this.selectedTotalProduct.id).subscribe(totalQuantity => {
        this.totalTotalProductQuantity = totalQuantity;
      });

      this.loadingHistory = false;
    });
  }
}
